(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const pointer = matchMedia('(hover: hover) and (pointer: fine)');
  function initialize(root = document) {
    root.querySelectorAll('[data-ascend-art]').forEach(frame => {
      if (frame.dataset.initialized) return;
      frame.dataset.initialized = 'true';
      const reset = () => {
        frame.style.setProperty('--pointer-x', '0px');
        frame.style.setProperty('--pointer-y', '0px');
      };
      frame.addEventListener('pointermove', event => {
        if (motion.matches || !pointer.matches) return;
        const rect = frame.getBoundingClientRect();
        frame.style.setProperty('--pointer-x', `${((event.clientX - rect.left) / rect.width - .5) * 10}px`);
        frame.style.setProperty('--pointer-y', `${((event.clientY - rect.top) / rect.height - .5) * 10}px`);
      });
      frame.addEventListener('pointerleave', reset);
    });
    root.querySelectorAll('.ascend-mobile-menu').forEach(menu => {
      if (menu.dataset.initialized) return;
      menu.dataset.initialized = 'true';
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          menu.open = false;
          menu.querySelector('summary').focus();
        }
      });
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('click', event => {
    document.querySelectorAll('.ascend-mobile-menu[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  if (document.documentElement.dataset.preview === 'true') {
    document.querySelectorAll('form[data-preview-form]').forEach(form => {
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        const status = form.querySelector('[role="status"]');
        status.textContent = 'Preview only — nothing was sent or saved. This form connects when the theme is installed on Shopify.';
      });
    });
  }
})();
